export default function AppDownload() {
  return (
    <section className="w-full py-8 md:py-12 px-4 md:px-6 lg:px-8">
      <div className="w-full flex flex-col md:flex-row items-center justify-between gap-6 md:gap-10">
        <div className="flex-1 text-center md:text-left">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-background-50 mb-2">
            Get the KenStore App
          </h2>
          <p className="text-sm md:text-base text-background-200 mb-4 max-w-md">
            Shop on the go, get exclusive app-only deals, track your orders, and receive instant notifications.
          </p>
          <div className="flex items-center gap-3 justify-center md:justify-start">
            <a
              href="/app"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-background-50 text-foreground-950 text-sm font-semibold hover:bg-background-100 transition-colors"
            >
              <i className="ri-apple-fill text-lg" />
              App Store
            </a>
            <a
              href="/app"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-background-50 text-foreground-950 text-sm font-semibold hover:bg-background-100 transition-colors"
            >
              <i className="ri-google-play-fill text-lg" />
              Play Store
            </a>
          </div>
        </div>
        <div className="flex-shrink-0">
          <div className="w-32 h-32 md:w-40 md:h-40 rounded-2xl bg-background-50 flex items-center justify-center shadow-lg">
            <div className="text-center">
              <i className="ri-smartphone-line text-4xl md:text-5xl text-primary-500 mb-1" />
              <p className="text-xs text-foreground-700 font-medium">Download Now</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}